import styled, { AnyStyledComponent } from "styled-components";

export const NewsletterLogoContainer: AnyStyledComponent = styled.div`
  margin: 0 auto 16px;

  img {
    max-width: 220px;
  }
`;
